import { global_footer_image_links } from '../../utils/requests/contentstack/contentStackZodSchema';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';
import type { FooterImageLinksProps } from './FooterImageLinks';

export const footerImageLinksSchema =
  global_footer_image_links.transform<FooterImageLinksProps>(data => ({
    title: data.title,
    links: data.links.map(link => ({
      caption: link.caption,
      href: link.href,
      image: getCloudinaryImageFields({
        alt: link.image.alt_text,
        cloudinaryField: link.image.src,
        shouldUseV2: true,
      }),
    })),
  }));
